module.exports = __webpack_public_path__ + "img/weichat-logo.14154463.svg";